<div [class]="isClaimWide ? 'confirm-page' : (isPublicView ? 'confirm-shell' : 'w-100 p-2')"
     [class.confirm-shell--baja]="isPublicView && !isClaimWide && !isLoading && isUnsubscribe"
     [class.confirm-shell--membership]="isPublicView && !isClaimWide && !isLoading && isMembershipProcess">

    @if (isClaimWide) {
        <header class="confirm-topbar">
            <div class="confirm-topbar__brand">
                <i class="fas fa-shield-alt"></i>
                <div>
                    <strong>Fondo de Protección Vehicular</strong>
                    <span>{{ expressApprovalTitle }}</span>
                </div>
            </div>
            @if (!isProcessed && timeLeftStr) {
                <div class="confirm-chip">
                    <i class="fas fa-hourglass-half"></i>
                    <span>Expira en {{ timeLeftStr }}</span>
                </div>
            }
        </header>
        <div class="confirm-grid">
            <div class="confirm-grid__summary">
                @if (isProcessed) {
                    <div class="confirm-card confirm-card--status">
                        <i class="fas fa-check-circle text-success"></i>
                        <div>
                            <strong>Solicitud procesada</strong>
                            <p class="mb-0">Esta solicitud ya no está pendiente de aprobación.</p>
                            <small>{{ requestData?.statusObj?.name || requestData?.statusSlug }}
                                @if (confirmedDate || requestData?.confirmedAt) {
                                    · {{ confirmedDate || (requestData?.confirmedAt | date: 'dd/MM/yyyy HH:mm') }}
                                }
                            </small>
                        </div>
                    </div>
                }
                @if (claimData) {
                    <app-preview-claim
                        [claim]="claimData"
                        [party]="partyData"
                        [request]="requestData"
                        [showActions]="!isProcessed"
                        [isSubmitting]="isSubmitting"
                        (approve)="confirmAction('CONFIRM')"
                        (reject)="confirmAction('REJECT')">
                    </app-preview-claim>
                } @else {
                    <div class="confirm-card text-muted small">No se encontró la ficha del siniestro asociada a este enlace.</div>
                }
                <div class="confirm-grid__pdf-toggle">
                    <button type="button" class="btn btn-outline-primary w-100" (click)="openClaimInforme()">
                        <i class="fas fa-file-pdf me-2"></i> Ver informe
                    </button>
                </div>
            </div>
            <div class="confirm-grid__pdf">
                <div class="confirm-pdf">
                    <app-claim-informe-pdf #claimInforme [inline]="true"></app-claim-informe-pdf>
                </div>
            </div>
        </div>
    } @else {
    <div class="card shadow-lg border-0 rounded-4 w-100">

        @if (isLoading) {
            <div class="card-header bg-primary text-white text-center py-4 rounded-top-2">
                <h3 class="fw-bold mb-1"><i class="fas fa-shield-alt me-2"></i>Fondo de Protección Vehicular</h3>
                <p class="mb-0 text-white-50">Validación de enlace</p>
            </div>
            <div class="card-body p-4 p-md-5">
                <div class="text-center py-5">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;"></div>
                    <p class="mt-3 text-muted">Validando token de seguridad...</p>
                </div>
            </div>
        } @else if (!isValid || isExpired) {
            <div class="card-header text-white text-center py-4 rounded-top-2" [class.bg-danger]="isUnsubscribe" [class.bg-primary]="!isUnsubscribe">
                <h3 class="fw-bold mb-1"><i class="fas fa-shield-alt me-2"></i>Fondo de Protección Vehicular</h3>
                <p class="mb-0 text-white-50">{{ isClaimProcess ? expressApprovalTitle : (isUnsubscribe ? 'Confirmación Oficial de Solicitud de Baja' : 'Validación de Solicitud de Incorporación') }}</p>
            </div>
            <div class="card-body p-4 p-md-5">
                <div class="text-center py-4">
                    <div class="mb-3 text-warning">
                        <i class="fas fa-exclamation-triangle fa-4x"></i>
                    </div>
                    <h4 class="fw-bold text-dark">Enlace No Válido o Expirado</h4>
                    <p class="text-muted">
                        El enlace ingresado no es válido o ha superado el tiempo límite de 48 horas.
                    </p>
                    <div class="alert alert-light border mt-4 text-start small">
                        <i class="fas fa-info-circle me-1 text-primary"></i>
                        @if (isClaimProcess) {
                            Si este enlace venció y la solicitud sigue pendiente, se enviará un enlace nuevo de forma automática al correo del revisor. También puede resolverla desde la bandeja.
                        } @else if (isUnsubscribe) {
                            Si este enlace venció y la solicitud de baja sigue pendiente, se enviará un enlace nuevo de forma automática al correo del socio.
                        } @else if (isMembershipProcess) {
                            Si este enlace venció y la solicitud de incorporación sigue pendiente, se renovará de forma automática o puede solicitar uno nuevo a la administración.
                        } @else {
                            Si el enlace no funciona, solicite uno nuevo a la administración de su entidad.
                        }
                    </div>
                </div>
            </div>
        } @else if (isMembershipProcess) {
            <div class="card-header bg-primary text-white text-center py-4 rounded-top-2">
                <h3 class="fw-bold mb-1"><i class="fas fa-user-check me-2"></i>Fondo de Protección Vehicular</h3>
                <p class="mb-0 text-white-50">Validación de Solicitud de Incorporación</p>
            </div>
            <div class="card-body p-4 p-md-5">
                @if (isProcessed) {
                    <div class="text-center py-4">
                        <div class="mb-3 text-success">
                            <i class="fas fa-check-circle fa-4x"></i>
                        </div>
                        <h4 class="fw-bold text-dark">Solicitud Procesada</h4>
                        <p class="text-muted">
                            Esta solicitud de incorporación ya ha sido evaluada y registrada en el sistema.
                        </p>
                        <div class="p-3 bg-light border rounded-3 text-start mb-3 small mx-auto" style="max-width: 520px;">
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2">
                                <span class="text-muted">Estado del Trámite:</span>
                                <strong class="text-success">{{ requestData?.statusObj?.name || requestData?.statusSlug }}</strong>
                            </div>
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2" *ngIf="requestData?.confirmedAt || confirmedDate">
                                <span class="text-muted">Fecha de Procesamiento:</span>
                                <strong class="text-dark">{{ confirmedDate || (requestData?.confirmedAt | date: 'dd/MM/yyyy HH:mm') }}</strong>
                            </div>
                            <div class="d-flex justify-content-between" *ngIf="requestData?.party">
                                <span class="text-muted">Socio / Postulante:</span>
                                <strong class="text-dark">{{ requestData?.party?.names }} {{ requestData?.party?.lastNames }} ({{ requestData?.party?.rut }})</strong>
                            </div>
                        </div>
                        <div class="d-flex gap-2 justify-content-center mt-3">
                            <button type="button" class="btn btn-outline-primary btn-sm" (click)="openMembershipPdf()">
                                <i class="fas fa-file-pdf me-1"></i> Ver Ficha Solicitud (PDF)
                            </button>
                        </div>
                    </div>
                } @else {
                    <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                        <h5 class="fw-bold text-dark m-0">
                            <i class="fas fa-id-card text-primary me-2"></i>Resumen de Solicitud de Incorporación
                        </h5>
                        <button type="button" class="btn btn-outline-primary btn-sm" (click)="openMembershipPdf()">
                            <i class="fas fa-file-pdf me-1"></i> Ver Ficha en PDF
                        </button>
                    </div>

                    @if (timeLeftStr) {
                        <div class="alert alert-warning border-warning d-flex align-items-center gap-2 py-2 px-3 mb-3">
                            <i class="fas fa-hourglass-half text-warning"></i>
                            <span>Este enlace de confirmación expirará en: <strong class="text-dark font-monospace">{{ timeLeftStr }}</strong></span>
                        </div>
                    }

                    <div class="p-3 bg-light rounded-3 mb-3 border">
                        <div class="row g-2">
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">Socio / Postulante:</span>
                                <strong class="text-dark">{{ requestData?.party?.names }} {{ requestData?.party?.lastNames }}</strong>
                            </div>
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">RUT:</span>
                                <strong class="text-dark">{{ requestData?.party?.rut }}</strong>
                            </div>
                            <div class="col-sm-6 mt-2">
                                <span class="text-muted small d-block">Correo Electrónico:</span>
                                <strong class="text-dark">{{ requestData?.party?.mail || 'No informado' }}</strong>
                            </div>
                            <div class="col-sm-6 mt-2">
                                <span class="text-muted small d-block">Teléfono Móvil:</span>
                                <strong class="text-dark">{{ requestData?.party?.mobileNumber || 'No informado' }}</strong>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <span class="text-muted small d-block">Entidad FPV:</span>
                                <strong class="text-dark">{{ requestData?.entity?.code }} - {{ requestData?.entity?.name }}</strong>
                            </div>
                        </div>
                    </div>

                    @if (requestData?.vehicle) {
                        <div class="p-3 bg-light rounded-3 mb-3 border">
                            <div class="row g-2">
                                <div class="col-sm-6">
                                    <span class="text-muted small d-block">Patente Vehículo:</span>
                                    <strong class="text-primary fs-5">{{ requestData?.vehicle?.plate }}</strong>
                                </div>
                                <div class="col-sm-6">
                                    <span class="text-muted small d-block">Año:</span>
                                    <strong class="text-dark">{{ requestData?.vehicle?.year }}</strong>
                                </div>
                                <div class="col-sm-6 mt-2">
                                    <span class="text-muted small d-block">Marca / Modelo:</span>
                                    <strong class="text-dark">{{ requestData?.vehicle?.brand?.name }} {{ requestData?.vehicle?.model?.name }}</strong>
                                </div>
                                <div class="col-sm-6 mt-2">
                                    <span class="text-muted small d-block">Color:</span>
                                    <strong class="text-dark">{{ requestData?.vehicle?.color || 'No especificado' }}</strong>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="alert alert-info border-info-subtle small mt-3 mb-4">
                        <i class="fas fa-info-circle me-1 text-primary"></i>
                        Al pulsar <strong>Aprobar Incorporación</strong>, la solicitud quedará validada y avanzará en el flujo BPM hacia la siguiente etapa o activación oficial.
                    </div>

                    <div class="d-flex gap-3 justify-content-center pt-2">
                        <button type="button" class="btn btn-success btn-lg px-4" [disabled]="isSubmitting" (click)="confirmAction('CONFIRM')">
                            @if (isSubmitting) {
                                <span class="spinner-border spinner-border-sm me-2"></span>
                            } @else {
                                <i class="fas fa-check-circle me-2"></i>
                            }
                            Aprobar Incorporación
                        </button>
                        <button type="button" class="btn btn-outline-danger btn-lg px-4" [disabled]="isSubmitting" (click)="confirmAction('REJECT')">
                            <i class="fas fa-times me-2"></i>Rechazar
                        </button>
                    </div>
                }
            </div>
            <app-membership-informe-pdf
                #membershipPdf
                [request]="requestData"
                [party]="partyData"
                [vehicle]="requestData?.vehicle">
            </app-membership-informe-pdf>
        } @else if (isUnsubscribe) {
            <div class="card-header bg-danger text-white text-center py-4 rounded-top-2">
                <h3 class="fw-bold mb-1"><i class="fas fa-shield-alt me-2"></i>Fondo de Protección Vehicular</h3>
                <p class="mb-0 text-white-50">Confirmación Oficial de Solicitud de Baja</p>
            </div>

            <div class="card-body p-4 p-md-5">
                <div *ngIf="isValid && isProcessed" class="text-center py-4">
                    <div class="mb-3 text-success">
                        <i class="fas fa-check-circle fa-4x"></i>
                    </div>
                    <h4 class="fw-bold text-dark">Solicitud Procesada Exitosamente</h4>
                    <p class="text-muted">
                        Esta solicitud ha sido autorizada y registrada en el sistema.
                    </p>

                    <div class="p-3 bg-light border rounded-3 text-start mb-3 small">
                        <div class="d-flex justify-content-between border-bottom pb-2 mb-2">
                            <span class="text-muted">Estado del Trámite:</span>
                            <strong class="text-success">{{ requestData?.statusObj?.name || (requestData?.statusSlug === 'APPROVED' ? 'Aprobado' : requestData?.statusSlug) }}</strong>
                        </div>
                        <div class="d-flex justify-content-between border-bottom pb-2 mb-2" *ngIf="requestData?.confirmedAt || confirmedDate">
                            <span class="text-muted">Fecha y Hora de Autorización:</span>
                            <strong class="text-dark">{{ confirmedDate || (requestData?.confirmedAt | date: 'dd/MM/yyyy HH:mm') }}</strong>
                        </div>
                        <div class="d-flex justify-content-between" *ngIf="requestData?.vehicle">
                            <span class="text-muted">Vehículo:</span>
                            <strong class="text-dark">{{ requestData?.vehicle?.plate }} - {{ requestData?.vehicle?.brand?.name }} {{ requestData?.vehicle?.model?.name }}</strong>
                        </div>
                    </div>

                    <div class="d-flex gap-2 justify-content-center mt-3">
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="openPdfModal(pdfModal)">
                            <i class="fas fa-file-pdf me-1"></i> Ver Comprobante (PDF)
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="downloadPDF()">
                            <i class="fas fa-download me-1"></i> Descargar PDF
                        </button>
                    </div>

                    <span class="badge bg-success-subtle text-success fs-6 px-3 py-2 border border-success mt-3 d-inline-block">
                        <i class="fas fa-check me-1"></i> Autorización Registrada
                    </span>
                </div>

                <div *ngIf="isValid && !isProcessed">
                    <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                        <h5 class="fw-bold text-dark m-0">
                            <i class="fas fa-file-invoice text-danger me-2"></i>Resumen de la Solicitud
                        </h5>
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="openPdfModal(pdfModal)">
                            <i class="fas fa-file-pdf me-1"></i> Ver PDF Solicitud
                        </button>
                    </div>

                    <div *ngIf="timeLeftStr" class="alert alert-warning border-warning d-flex align-items-center gap-2 py-2 px-3 mb-3">
                        <i class="fas fa-hourglass-half text-warning"></i>
                        <span>Este enlace de confirmación expirará en: <strong class="text-dark font-monospace">{{ timeLeftStr }}</strong></span>
                    </div>

                    <div class="p-3 bg-light rounded-3 mb-3 border">
                        <div class="row g-2">
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">Socio / Propietario:</span>
                                <strong class="text-dark">{{ requestData?.party?.names }} {{ requestData?.party?.lastNames }}</strong>
                            </div>
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">RUT:</span>
                                <strong class="text-dark">{{ requestData?.party?.rut }}</strong>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <span class="text-muted small d-block">Entidad:</span>
                                <strong class="text-dark">{{ requestData?.entity?.code }} - {{ requestData?.entity?.name }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="p-3 bg-light rounded-3 mb-3 border" *ngIf="requestData?.vehicle">
                        <div class="row g-2">
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">Patente Vehículo:</span>
                                <strong class="text-danger fs-5">{{ requestData?.vehicle?.plate }}</strong>
                            </div>
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">Año:</span>
                                <strong class="text-dark">{{ requestData?.vehicle?.year }}</strong>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <span class="text-muted small d-block">Marca / Modelo:</span>
                                <strong class="text-dark">{{ requestData?.vehicle?.brand?.name }} {{ requestData?.vehicle?.model?.name }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4">
                        <label class="form-label text-muted small fw-bold text-uppercase">Motivo del Trámite</label>
                        <p class="p-3 bg-white border rounded italic text-secondary">
                            "{{ requestData?.reason || 'Solicitud voluntaria de baja de cobertura' }}"
                        </p>

                        <div class="alert alert-info border-info small mb-0">
                            <i class="fas fa-clock me-1"></i> <strong>Información de Vigencia (Regla Día 10 FPV):</strong>
                            <ng-container *ngIf="getCurrentDay() <= 10; else postTen">
                                Al confirmar hoy, la desafiliación del cobro de la prima y cobertura toma efecto <strong>inmediatamente en el mes actual</strong>.
                            </ng-container>
                            <ng-template #postTen>
                                Al estar confirmando después del día 10 del mes en curso, el vehículo mantiene cobertura el resto del mes y el cese de cobro de primas regirá a contar del <strong>1° del mes siguiente</strong>.
                            </ng-template>
                        </div>
                    </div>

                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-danger btn-lg fw-bold shadow-sm" (click)="confirmAction('CONFIRM')" [disabled]="isSubmitting">
                            <i class="fas fa-check-circle me-2" [class.fa-spin]="isSubmitting"></i> Confirmar y Autorizar Baja
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-md" (click)="confirmAction('REJECT')" [disabled]="isSubmitting">
                            <i class="fas fa-times-circle me-1"></i> Rechazar Solicitud
                        </button>
                    </div>
                </div>
            </div>
        } @else {
            <div class="card-header bg-primary text-white text-center py-4 rounded-top-2">
                <h3 class="fw-bold mb-1"><i class="fas fa-shield-alt me-2"></i>Fondo de Protección Vehicular</h3>
                <p class="mb-0 text-white-50">{{ requestData?.process?.name || 'Validación de solicitud' }}</p>
            </div>
            <div class="card-body p-4 p-md-5">
                @if (isClaimProcess && claimData) {
                    <app-preview-claim
                        [claim]="claimData"
                        [party]="partyData"
                        [request]="requestData"
                        [showActions]="!isProcessed"
                        [isSubmitting]="isSubmitting"
                        (approve)="confirmAction('CONFIRM')"
                        (reject)="confirmAction('REJECT')">
                    </app-preview-claim>
                } @else {
                    <div class="p-3 bg-light rounded-3 mb-3 border">
                        <div class="row g-2">
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">Proceso:</span>
                                <strong class="text-dark">{{ requestData?.process?.name || processSlug || 'Solicitud' }}</strong>
                            </div>
                            <div class="col-sm-6">
                                <span class="text-muted small d-block">Socio:</span>
                                <strong class="text-dark">{{ partyData?.names }} {{ partyData?.lastNames }}</strong>
                            </div>
                            <div class="col-sm-6 mt-2">
                                <span class="text-muted small d-block">Patente:</span>
                                <strong class="text-dark">{{ requestData?.vehicle?.plate || claimData?.vehicle?.plate || 'S/N' }}</strong>
                            </div>
                        </div>
                    </div>
                    @if (isVehicleUpdate && proposedChangeRows.length) {
                        <div class="mb-4">
                            <h6 class="fw-bold text-dark mb-2">
                                <i class="fas fa-exchange-alt text-primary me-2"></i>Cambios propuestos
                            </h6>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>Campo</th>
                                            <th>Actual</th>
                                            <th>Propuesto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (row of proposedChangeRows; track row.key) {
                                            <tr>
                                                <td>{{ row.label }}</td>
                                                <td>{{ row.from }}</td>
                                                <td class="fw-semibold text-primary">{{ row.to }}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                    @if (!isProcessed) {
                        <div class="d-flex gap-3 justify-content-center pt-2">
                            <button type="button" class="btn btn-success btn-lg px-4" [disabled]="isSubmitting" (click)="confirmAction('CONFIRM')">
                                Confirmar
                            </button>
                            <button type="button" class="btn btn-outline-danger btn-lg px-4" [disabled]="isSubmitting" (click)="confirmAction('REJECT')">
                                Rechazar
                            </button>
                        </div>
                    }
                }
            </div>
        }

        <div class="card-footer bg-light text-center py-3 rounded-bottom-2 small text-muted border-top d-flex justify-content-between align-items-center flex-wrap gap-2">
            <ng-content select="[footer]"></ng-content>
        </div>
    </div>
    }
</div>

<ng-template #pdfModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Previsualización de Documento</h4>
        <div class="ms-auto d-flex align-items-center">
            <a [href]="pdfSrc" class="btn btn-success btn-sm me-2" target="_blank" *ngIf="pdfSrc">
                <i class="fas fa-external-link-alt me-1"></i> Abrir en nueva pestaña
            </a>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
    </div>
    <div class="modal-body p-0">
        <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="600px" style="border: none;"></iframe>
    </div>
</ng-template>

<div style="display: none;">
    <table id="hidden-baja-table" style="width: 100%; font-family: 'Helvetica', Arial, sans-serif; color: #212529; background-color: #ffffff; border: 1px solid #999a9a;">
        <tbody>
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    1. IDENTIFICACIÓN DEL SOCIO / PROPIETARIO
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; width: 20%; font-size: 9pt;">Rut:</td>
                <td style="padding: 8px; width: 30%; font-size: 9pt;">{{ requestData?.party?.rut }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; width: 20%; font-size: 9pt;">Tipo de Socio:</td>
                <td style="padding: 8px; width: 30%; font-size: 9pt;">{{ requestData?.party?.groupName || 'Socio Afiliado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Nombres:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ requestData?.party?.names }} {{ requestData?.party?.lastNames }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Correo Socio:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.party?.mail || 'No registrado' }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Móvil:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.party?.mobileNumber || 'No registrado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Entidad:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">
                    {{ requestData?.entity?.code }} - {{ requestData?.entity?.name }}
                </td>
            </tr>

            @if(requestData?.vehicle){
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    2. IDENTIFICACIÓN DEL VEHÍCULO
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Patente:</td>
                <td style="padding: 8px; font-size: 10pt;">{{ requestData?.vehicle?.plate }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Año:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.year }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Marca / Modelo:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.brand?.name }} {{ requestData?.vehicle?.model?.name }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Color:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.colorName || requestData?.vehicle?.color || 'N/A' }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">VIN / Motor:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.vin || 'N/A' }}</td>
            </tr>
            }

            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    3. MOTIVO, TOKEN Y FECHA DE APROBACIÓN
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Estado Trámite:</td>
                <td style="padding: 8px; font-weight: bold; font-size: 9pt; color: #198754;">{{ requestData?.statusObj?.name || (requestData?.statusSlug === 'APPROVED' ? 'APROBADO' : 'EN PROCESO') }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Correo Token:</td>
                <td style="padding: 8px; font-size: 9pt; font-weight: bold;">{{ requestData?.party?.mail || 'No registrado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Token Autorización:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-family: monospace; font-weight: bold; color: #d9534f; word-break: break-all;">
                    {{ requestData?.confirmationToken || token }}
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Fecha Aprobación:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-weight: bold; color: #0d6efd;">
                    {{ confirmedDate || (requestData?.confirmedAt ? (requestData?.confirmedAt | date: 'dd/MM/yyyy HH:mm:ss') : 'Pendiente de confirmación') }}
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Motivo / Causal:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-style: italic;">{{ requestData?.reason || 'No especificado' }}</td>
            </tr>
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <td colspan="4" style="text-align: justify; padding: 25px; color: #6C757D; font-size: 8.5pt; line-height: 1.6;">
                    Declaro conocer y estar dispuesto a respetar los reglamentos del Fondo de Protección Vehicular (FPV) y renuncio a toda acción civil en contra de este Fondo, cuyo fin es prestar servicio a los religiosos o empleados de la Organización Iglesia Adventista. Acepto, además, las decisiones que la comisión del Fondo P.V. determine de manera libre y espontánea en relación a esta solicitud de baja.
                </td>
            </tr>
        </tbody>
    </table>
</div>
